'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _loader = require('../loader');

var _loader2 = _interopRequireDefault(_loader);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var cx = _bind2.default.bind(_style2.default);

var ContentBlock = function ContentBlock(_ref) {
  var children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === undefined ? 'primary' : _ref$appearance,
      _ref$fetching = _ref.fetching,
      fetching = _ref$fetching === undefined ? false : _ref$fetching,
      wrapperClassName = _ref.wrapperClassName,
      className = _ref.className;
  return React.createElement('div', {
    className: cx('xsui-content-block', 'xsui-content-block--appearance-' + appearance, wrapperClassName)
  }, fetching ? React.createElement(_loader2.default, {
    fullscreen: true,
    size: 'lg',
    color: appearance === 'branding' ? 'white' : 'gray'
  }) : React.createElement('div', {
    className: cx('xsui-content-block__entry', className)
  }, children));
};

ContentBlock.propTypes = {
  children: _propTypes2.default.node,
  appearance: _propTypes2.default.oneOf(['primary', 'flatten', 'branding', 'modal']),
  fetching: _propTypes2.default.bool,
  wrapperClassName: _propTypes2.default.string,
  className: _propTypes2.default.string
};
exports.default = ContentBlock;